import {
  Popover,
  PopoverTrigger,
  Button,
  PopoverContent,
  PopoverBody,
  Icon,
  useDisclosure,
  useOutsideClick,
  Box,
} from '@chakra-ui/react';
import { useMemo, useRef, useState, useEffect } from 'react';
import { outreachFunctions } from '@/constants/outreach-functions';
import { ChevronDownIcon } from '@heroicons/react/solid';
import { FilterItem } from './FilterItem';
import DepartmentIcon from '@/assets/icons/blueprint/Department';
import { KText } from '@/ui-library/components/text';

export const BlueprintFunctions = ({ onSelect = () => {}, filter = {} }) => {
  const functions = useMemo(() => {
    return [{ label: 'All Departments', value: 'all' }, ...outreachFunctions];
  }, []);
  const defaultSelected = functions[0];
  const [selected, setSelected] = useState(defaultSelected);
  const ref = useRef(null);
  const { isOpen, onToggle, onClose } = useDisclosure();

  useEffect(() => {
    if (filter?.function === null) {
      setSelected(defaultSelected);
    }
  }, [filter]); //eslint-disable-line react-hooks/exhaustive-deps

  useOutsideClick({
    ref: ref,
    handler: () => onClose(),
  });

  return (
    <Box as="span" ref={ref}>
      <Popover placement="bottom-start" isOpen={isOpen}>
        <PopoverTrigger>
          <Button
            px="6px"
            height="2rem"
            variant="quaternary"
            bg="primary-50"
            borderColor="transparent"
            textDecoration="none"
            onClick={onToggle}
            borderRadius="6px"
            _hover={{ textDecoration: 'none' }}
            _focus={{ textDecoration: 'none' }}
            leftIcon={
              <Icon
                as={DepartmentIcon}
                width="16px"
                height="16px"
                color="secondary-700"
              />
            }
          >
            <KText size="sm-medium" color="secondary-700">
              {selected?.label}
            </KText>
            <Icon
              transitionDuration=".5s"
              willChange="transform"
              transform={isOpen ? 'rotateX(180deg)' : 'rotateX(0)'}
              as={ChevronDownIcon}
              width="16px"
              height="16px"
              color="secondary-700"
            />
          </Button>
        </PopoverTrigger>
        <PopoverContent
          minH="100px"
          w="180px"
          boxShadow="0px 4px 12px 6px rgb(46 47 48 / 6%)"
        >
          <PopoverBody display="flex" flexDir="column" p="0">
            {functions?.map((filter, idx) => {
              return (
                <FilterItem
                  key={idx}
                  item={filter}
                  onSelect={(item) => {
                    onSelect(item);
                    setSelected(item);
                    onClose();
                  }}
                >
                  <KText>{filter?.label}</KText>
                </FilterItem>
              );
            })}
          </PopoverBody>
        </PopoverContent>
      </Popover>
    </Box>
  );
};
